import EarthIcon from "mdi-react/EarthIcon.js";
import FileDocumentOutlineIcon from "mdi-react/FileDocumentOutlineIcon.js";
import EthereumIcon from "mdi-react/EthereumIcon.js";
import FileDocumentMultipleOutlineIcon from "mdi-react/FileDocumentMultipleOutlineIcon.js";
import FileSignIcon from "mdi-react/FileSignIcon.js";
import FileDocumentPlusOutlineIcon from "mdi-react/FileDocumentPlusOutlineIcon.js";
import {
    FILTER_KEY_CRYPTO,
    FILTER_KEY_FUNDS,
    FILTER_KEY_LIQUID,
    FILTER_KEY_MANAGED,
    FILTER_KEY_PAPER,
    FILTER_KEY_REAL_ESTATE,
    FILTER_KEY_STOCKS,
    FILTER_KEY_STOCKS_UNLISTED,
} from "../../../ducks/assets-duck.js";
import DropOutlineIcon from "mdi-react/DropOutlineIcon.js";
import FileMultipleOutlineIcon from "mdi-react/FileMultipleOutlineIcon.js";
import './AssetIcon.scss'
import HomeOutlineIcon from "mdi-react/HomeOutlineIcon.js";
import DogIcon from "mdi-react/DogIcon.js";

export default ({
                    assetType = '',
                    assetId,
                    filterPreset = '',
                    isColored = false,
                    className = '',
                }) => {
    let Icon = EarthIcon
    let colorClassName = ''
    const assetTypeLowerCaps = assetType?.toLowerCase()
    if (filterPreset === FILTER_KEY_MANAGED) {
        Icon = FileDocumentPlusOutlineIcon
    } else if (filterPreset === FILTER_KEY_LIQUID) {
        Icon = DropOutlineIcon
    } else if (filterPreset === FILTER_KEY_PAPER) {
        Icon = FileMultipleOutlineIcon
    } else if (assetTypeLowerCaps?.includes('crypto') || filterPreset === FILTER_KEY_CRYPTO) {
        Icon = EthereumIcon
        colorClassName = 'is-crypto'
    } else if (assetTypeLowerCaps === 'stock-unlisted' || filterPreset === FILTER_KEY_STOCKS_UNLISTED) {
        Icon = FileSignIcon
        colorClassName = 'is-stock'
    } else if (assetTypeLowerCaps?.includes('stock') || filterPreset === FILTER_KEY_STOCKS) {
        Icon = FileDocumentOutlineIcon
        colorClassName = 'is-stock'
    } else if (assetTypeLowerCaps?.includes('fund') || filterPreset === FILTER_KEY_FUNDS) {
        Icon = FileDocumentMultipleOutlineIcon
        colorClassName = 'is-fund'
    }  else if (assetTypeLowerCaps?.includes('real') || filterPreset === FILTER_KEY_REAL_ESTATE) {
        Icon = HomeOutlineIcon
        colorClassName = 'is-real-estate'
    } else if (filterPreset?.toLowerCase().includes('dawg')) {
        Icon = DogIcon
        colorClassName = 'is-real-estate'
    }
    return <Icon className={`asset-icon ${isColored ? colorClassName : ''} ${className}`}/>
}